import { BASEMAP_NAME } from '../../lib/map_config'

/**
 * Shown when MapLibre could not build a map at all — v6 requires WebGL2 and its
 * constructor throws rather than degrading. This is the notice only: the atlas
 * list it points at lives in the layout, because the same list is also the
 * keyboard and screen-reader path through a canvas that works perfectly well.
 *
 * Placed and skinned exactly as `MapUnavailable` is, for the reason given
 * there: below the header, which is still working and must stay reachable.
 */
export default function MapUnsupported() {
  return (
    <div
      role="alert"
      className="absolute inset-x-3 top-28 z-20 mx-auto max-w-xl rounded-2xl bg-amber-50 px-4 py-3 text-sm text-amber-950 shadow-chrome ring-1 ring-amber-300 md:top-20"
    >
      <p className="font-display text-[17px] font-semibold">This browser cannot draw the map</p>
      <p className="mt-1 leading-relaxed">
        The {BASEMAP_NAME} map needs WebGL2, which this browser or graphics driver does not provide. The
        atlas is listed below instead, and every place links to its own page.
      </p>
    </div>
  )
}
